import { useState, useEffect } from 'react';

const DEFAULT_BREAKPOINT = 800;

const getEffectiveViewportWidth = () => {
  if (typeof window === 'undefined') return DEFAULT_BREAKPOINT - 1;

  const innerWidth = window.innerWidth || Number.MAX_SAFE_INTEGER;
  const screenWidth = window.screen?.width || Number.MAX_SAFE_INTEGER;

  return Math.min(innerWidth, screenWidth);
};

const useIsMobile = (breakpoint = DEFAULT_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return true;
    return getEffectiveViewportWidth() < breakpoint;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getEffectiveViewportWidth() < breakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
